import { Apple } from "lucide-react";

function PlayStoreIcon({ size = 18 }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
        >
            <path d="M3.6 1.7c-.4.3-.6.8-.6 1.4v17.8c0 .6.2 1.1.6 1.4l9.6-10.3L3.6 1.7zm10.7 11.5l2.6 2.8-9.5 5.4 6.9-8.2zm0-2.3L7.4 2.7l9.5 5.4-2.6 2.8zm6.4-.5c1.1.6 1.1 2.1 0 2.6l-2.3 1.3-2.9-3.1 2.9-3.1 2.3 1.3z" />
        </svg>
    );
}

// Fires the Google Ads conversion event and navigates to the store URL.
// Uses event_callback for accurate attribution, with a 300ms fallback so the
// user is never blocked if the beacon is slow. If gtag is unavailable, the
// user still navigates to the store.
const CONVERSION_SEND_TO = "AW-18414944796/qk8CCO6y-e4cEJyE98xE";

function trackDownload(url) {
    let done = false;
    const go = () => {
        if (done) return;
        done = true;
        window.location.href = url;
    };

    if (typeof window !== "undefined" && typeof window.gtag === "function") {
        try {
            window.gtag("event", "conversion", {
                send_to: CONVERSION_SEND_TO,
                event_callback: go,
            });
        } catch (_) {
            go();
            return false;
        }
        setTimeout(go, 300);
    } else {
        go();
    }

    return false;
}

const ANDROID_URL =
    "https://play.google.com/store/apps/details?id=com.Matrona_IA.app";
const IOS_URL = "https://apps.apple.com/es/app/matrona-ia/id6784016220";

export default function DownloadButtons({ size = "lg" }) {
    const padding = size === "lg" ? "px-7 py-4" : "px-5 py-3";
    const text = size === "lg" ? "text-[1rem]" : "text-[0.9rem]";

    const handleAndroid = (e) => {
        e.preventDefault();
        trackDownload(ANDROID_URL);
    };
    const handleIos = (e) => {
        e.preventDefault();
        trackDownload(IOS_URL);
    };

    return (
        <div className="flex flex-col sm:flex-row items-center gap-3.5 sm:gap-4">
            <a
                href={ANDROID_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleAndroid}
                data-testid="download-android-btn"
                className={`pill-primary btn-soft-shadow inline-flex items-center gap-3 ${padding} ${text}`}
                title="Descargar Matrona IA en Google Play"
            >
                <PlayStoreIcon size={20} />
                <span className="text-left leading-tight">
                    <span className="block text-[0.68rem] opacity-90 tracking-wider uppercase">
                        Disponible en
                    </span>
                    <span className="block font-medium">Descargar para Android</span>
                </span>
            </a>

            <a
                href={IOS_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleIos}
                data-testid="download-ios-btn"
                className={`pill-outline inline-flex items-center gap-3 ${padding} ${text}`}
                title="Descargar Matrona IA en la App Store"
            >
                <Apple size={20} />
                <span className="text-left leading-tight">
                    <span className="block text-[0.68rem] opacity-90 tracking-wider uppercase">
                        Disponible en el
                    </span>
                    <span className="block font-medium">Descargar para iPhone</span>
                </span>
            </a>
        </div>
    );
}
